import React, { useMemo } from 'react';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';
import { Colors, useScreenSize } from '@banhala/ui-kit';

export const WhiteLinearGradient: React.FC = () => {
  const { width: screenWidth } = useScreenSize();
  const size = useMemo(() => {
    return {
      width: screenWidth,
      height: screenWidth * (172 / 375),
    };
  }, [screenWidth]);
  return (
    <Svg
      width={size.width}
      height={size.height}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
    >
      <Rect
        width={size.width}
        height={size.height}
        fill="url(#paint0_linear_5399_142584)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_5399_142584"
          x1={size.width * 0.5}
          y1="0"
          x2={size.width * 0.5}
          y2={size.width * (100 / 375)}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={Colors.bg_always_white} stopOpacity="0" />
          <Stop offset="1" stopColor={Colors.bg_always_white} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
